import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { Droppable, DroppableProvided } from 'react-beautiful-dnd';
import { useHwcIndustryCategoryTemplates } from '../../../../queries';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { AccordionContentCategoryTemplateRow } from './AccordionContentCategoryTemplateRow';
import { styleSheet } from './styles';

export function AccordionContentCategoryTemplates({
	category,
	industry,
}: {
	category: Api.ITemplateCategory;
	industry: Api.Industry;
}) {
	const templatesQuery = useHwcIndustryCategoryTemplates({
		categoryName: category.name,
		industry,
	});
	return (
		<>
			{templatesQuery.isPending ? (
				<LoadingSpinner />
			) : (
				<>
					{(templatesQuery.data ?? []).length > 0 ? (
						<>
							<div className={css(styleSheet.campaignHeader)}>
								<div className={css(styleSheet.headerName)}>Campaign Name</div>
								<div className={css(styleSheet.headerIndustries)}>Industries</div>
								<div className={css(styleSheet.headerCreated)}>Created</div>
								<div className={css(styleSheet.headerActions)}>Actions</div>
							</div>
							<Droppable direction='vertical' droppableId={category.name} type={`templates-${category.name}`}>
								{(droppableProvided: DroppableProvided) => {
									return (
										<div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
											{(templatesQuery.data ?? []).map((template, index) => {
												return (
													<AccordionContentCategoryTemplateRow
														key={template.template.id}
														template={template}
														index={index}
														category={category}
														industry={industry}
													/>
												);
											})}
										</div>
									);
								}}
							</Droppable>
						</>
					) : null}
				</>
			)}
		</>
	);
}
